import React, { useState, useEffect } from "react";
import BookingHeader from "./components/BookingHeader";
import ServiceForm from "./components/Forms/ServiceForm/ServiceForm";
import StaffForm from "./components/Forms/StaffForm/StaffForm";
import DateForm from "./components/Forms/DateForm/DateForm";
import DetailsForm from "./components/Forms/ProvideDetailsForm/DetailsForm";
import { useBusinessContext } from "../../context/business";
import bookService from "../../actions/bookService/bookService";
import Summary from "./components/Summary/Summary";
import TotalCost from "./components/TotalCost/TotalCost";
import { useLocation } from "react-router-dom";

import logoIcon from "../../assets/svg/logo_icon.svg";

export default function Book() {
  const [currentStepIndex, setCurrentStepIndex] = useState(1);
  const useCurrentStep = () => [currentStepIndex, setCurrentStepIndex];

  const [showDateForm, setShowDateForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState();
  const {
    businessData: { businessData, loading },
    selectedBusiness, setSelectedBusiness
  } = useBusinessContext();

  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const [statusMessage, setStatusMessage] = useState(query.get("message") || "");


  const submitForm = (e) => {
    setErrors([]);
    if (e) e.preventDefault();
    const discount_code = localStorage.getItem("discount_code");


    if (currentStepIndex === 4) {
      setIsSubmitting(true)
      const groupService = selectedBusiness.services.find(s => s.is_group_session);

      bookService(
        {
          body: {
            discount_code: discount_code === undefined ? null : discount_code,
            team_member_id: selectedBusiness.staff.id,
            appointment_date: selectedBusiness.date,
            appointment_start_time: selectedBusiness.hour,
            services: selectedBusiness.services.map((service) => ({
              id: service.id,
            })),
            type: businessData.accepts_payment ? "paid" : "free",
            ...selectedBusiness.userDetails,
            // Only include service_id and quantity for group sessions
            ...(groupService && {
              service_id: groupService.id,
              quantity: groupService.quantity || 1,
            }),
          },
          businessID: businessData.identifier,
          staff: selectedBusiness.staff,
        },
        setErrors,
        () => setIsSubmitting(false)
      );
    }

    next();
  };

  const next = () =>
    setCurrentStepIndex((prev) => (prev < 4 ? prev + 1 : prev));

  const previous = () =>
    setCurrentStepIndex((prev) => (prev > 1 ? prev - 1 : prev));

  const [viewDetails, setViewDetails] = useState(false);

  const formStepProps = {
    currentStepIndex,
    submitForm,
    useViewDetails: () => ({
      setViewDetails,
      viewDetails,
    }),
  };

  useEffect(() => {
    if (businessData?.name) {
      let addressPart = '';

      if (businessData.location_type === "Physical Location" && !businessData.hide_business_address) {
        // Only show address for physical locations where address is visible
        const parts = [
          businessData.address,
          businessData.city,
          businessData.state
        ].filter(Boolean);
        addressPart = parts.join(', ');
      }

      document.title = `Book an appointment with ${businessData.name}${addressPart ? ` - ${addressPart}` : ''}`;

      document.querySelector(
        "meta[name=description]"
      ).content = `${businessData.name} uses Kindlybook to receive and manage appointments. See their services, prices, and opening hours. Book Now.`;
    }
    if (currentStepIndex === 1) {

      setSelectedBusiness({
        type: "RESET_SERVICES",
      });
    }
    setShowDateForm(currentStepIndex >= 3 ? true : false)
    if (currentStepIndex < 3) {
      setSelectedBusiness({ type: "SELECT_DATE", data: "" });
      setSelectedBusiness({ type: "SELECT_HOUR", data: "" });
      setSelectedBusiness({ type: "RESET_OPENING_HOURS" });
      setSelectedBusiness({
        type: "SELECT_HOUR",
        data: [],
      });
    }
  }, [businessData, currentStepIndex]);



  return (
    <>
      {!!businessData && (
        <div className="book_app">
          <div className="app_max_width">
            {currentStepIndex !== 1 ? (
              <div className="mbl flex mbl_header_bk">
                {!businessData.show_team_members && currentStepIndex === 2 ? (
                  ""
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      viewDetails ? setViewDetails(false) : previous();
                    }}
                    className="co_pink"
                  >
                    <svg
                      width="8"
                      height="14"
                      viewBox="0 0 8 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.48322 14C6.13386 14 5.78583 13.8572 5.52448 13.573L0.373415 7.97315C-0.130624 7.42296 -0.123956 6.55079 0.39075 6.0104L5.72449 0.41054C6.24453 -0.136847 7.0886 -0.136847 7.60997 0.41054C8.13001 0.957926 8.13001 1.8427 7.60997 2.39009L3.20297 7.01697L7.44196 11.6271C7.954 12.1842 7.93933 13.0704 7.40996 13.6066C7.14993 13.8698 6.81658 14 6.48322 14Z"
                        fill="#E40587"
                      />
                    </svg>
                    Back
                  </button>
                )}
              </div>
            ) : (
              <br />
            )}
            <BookingHeader
              dataisvisible={!viewDetails}
              currentStepIndex={currentStepIndex}
            />
            <div className="booking_grid">
              <div className="card" data-is-visible={!viewDetails}>
                <div className="form_header">
                  {businessData.show_team_members ? (
                    <HeaderButton useCurrentStep={useCurrentStep} index={1}>
                      Choose Staff
                    </HeaderButton>
                  ) : (
                    ""
                  )}
                  <HeaderButton useCurrentStep={useCurrentStep} index={2}>
                    Select Service
                  </HeaderButton>
                  <HeaderButton useCurrentStep={useCurrentStep} index={3}>
                    Choose Date & Time
                  </HeaderButton>
                  <HeaderButton useCurrentStep={useCurrentStep} index={4}>
                    Complete Booking
                  </HeaderButton>
                </div>

                <>
                  <div className="form_mbl">
                    <p className="form_mbl_title mbl">
                      Step{" "}
                      {currentStepIndex +
                        (businessData.show_team_members ? 0 : -1)}{" "}
                      of {businessData.show_team_members ? 4 : 3}
                    </p>
                    <p className="form_mbl_heading mbl">
                      {currentStepIndex === 1 && "Choose Staff"}
                      {currentStepIndex === 3 && "Choose Date & Time"}
                      {currentStepIndex === 4 && "Complete Booking"}
                    </p>
                  </div>
                  <StaffForm {...formStepProps} />
                  {(currentStepIndex >= 2) && (
                    <>
                      <TotalCost />
                      <ServiceForm {...formStepProps} />
                    </>

                  )}

                  {(currentStepIndex >= 3 && showDateForm) && (
                    <DateForm {...formStepProps} />
                  )}
                  <DetailsForm {...formStepProps} errors={errors} isSubmitting={isSubmitting}/>
                </>
              </div>

              <div>
                <div className="dsk">
                  <Summary currentStepIndex={currentStepIndex} />
                </div>
                <div className="mbl">{viewDetails && <Summary currentStepIndex={currentStepIndex} />}</div>
                <PoweredTag />
              </div>
            </div>
          </div>
        </div>
      )}

      {loading && (
        <div className="loading_screen">
          <div className="loading_content">
            <img src={logoIcon} width="64px" alt="Loading" />
            <p>Loading...</p>
          </div>
        </div>
      )}

      {!loading && !businessData && (
        <div>
          <div className="text-center business_not_found">
            <img src={logoIcon} width="64px" alt="Business not found" />
            <h3>Business Profile Unavailable</h3>
            {statusMessage == "" ?
              <p>The business page you are looking for has been closed or removed by
                the owner. </p> : <p>

                This business is no longer available on Kindlybook. Your payment will be refunded within 48 hours. If you have any questions, please contact us at <a href="mailto:hello@kindlybook.com"  >hello@kindlybook.com</a>.
              </p>}
            <div style={{ marginTop: "76px" }}>
              <a href="https://kindlybook.com">
                ← Return to Kindlybook
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function PoweredTag() {
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a href="https://kindlybook.com" target="_blank">
      <div className="pwd_by">
        Powered By{" "}
        <svg
          width="80"
          viewBox="0 0 379 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M85.52 15L71.248 29.592L69.776 30.616L59.728 41.048L59.664 33.24L77.392 15H85.52ZM62.16 0.599976V47H55.312V0.599976H62.16ZM72.08 25.752L86.288 47H78.352L66.96 29.656L72.08 25.752Z"
            fill="#1F1F1F"
          />
          <path
            d="M94.8005 9.62397C93.3072 9.62397 92.1552 9.26131 91.3445 8.53598C90.5765 7.76798 90.1925 6.70131 90.1925 5.33598C90.1925 3.97064 90.5765 2.92531 91.3445 2.19997C92.1552 1.47464 93.3072 1.11198 94.8005 1.11198C96.2512 1.11198 97.3605 1.47464 98.1285 2.19997C98.9392 2.92531 99.3445 3.97064 99.3445 5.33598C99.3445 6.70131 98.9392 7.76798 98.1285 8.53598C97.3605 9.26131 96.2512 9.62397 94.8005 9.62397ZM98.1925 15V47H91.3445V15H98.1925Z"
            fill="#1F1F1F"
          />
          <path
            d="M107.627 47V15H113.707L114.155 23.32L113.259 22.424C113.856 20.5893 114.71 19.0746 115.819 17.88C116.971 16.6426 118.315 15.7466 119.851 15.192C121.43 14.6373 123.094 14.36 124.843 14.36C127.104 14.36 129.131 14.808 130.923 15.704C132.758 16.5573 134.208 17.8586 135.275 19.608C136.342 21.3573 136.875 23.576 136.875 26.264V47H130.027V28.376C130.027 25.2186 129.366 23.0426 128.043 21.848C126.763 20.6106 125.142 19.992 123.179 19.992C121.771 19.992 120.406 20.3333 119.083 21.016C117.76 21.656 116.651 22.7013 115.755 24.152C114.902 25.6026 114.475 27.544 114.475 29.976V47H107.627Z"
            fill="#1F1F1F"
          />
          <path
            d="M158.26 47.64C155.615 47.64 153.204 46.9786 151.028 45.656C148.895 44.3333 147.209 42.4346 145.972 39.96C144.735 37.4853 144.116 34.52 144.116 31.064C144.116 27.48 144.777 24.4506 146.1 21.976C147.423 19.5013 149.193 17.624 151.412 16.344C153.631 15.0213 156.063 14.36 158.708 14.36C161.439 14.36 163.743 15.1066 165.62 16.6C167.497 18.0933 168.756 20.0346 169.396 22.424L168.628 23.128V0.599976H175.476V47H169.396L168.884 38.296L169.78 38.36C169.481 40.28 168.777 41.944 167.668 43.352C166.559 44.7173 165.172 45.784 163.508 46.552C161.887 47.2773 160.137 47.64 158.26 47.64ZM159.732 42.136C161.567 42.136 163.145 41.6666 164.468 40.728C165.791 39.7893 166.815 38.4666 167.54 36.76C168.265 35.0533 168.628 33.0053 168.628 30.616C168.628 28.3973 168.265 26.4986 167.54 24.92C166.815 23.2986 165.791 22.0613 164.468 21.208C163.188 20.3546 161.695 19.928 159.988 19.928C157.129 19.928 154.911 20.9093 153.332 22.872C151.753 24.8346 150.964 27.544 150.964 31C150.964 34.456 151.732 37.1866 153.268 39.192C154.804 41.1546 156.959 42.136 159.732 42.136Z"
            fill="#1F1F1F"
          />
          <path
            d="M191.473 0.599976V38.04C191.473 39.6186 191.75 40.7066 192.305 41.304C192.86 41.9013 193.777 42.2 195.057 42.2C195.825 42.2 196.465 42.1573 196.977 42.072C197.532 41.944 198.214 41.7306 199.025 41.432L198.257 46.552C197.532 46.8933 196.7 47.1493 195.761 47.32C194.822 47.5333 193.884 47.64 192.945 47.64C190.086 47.64 187.974 46.9146 186.609 45.464C185.286 43.9706 184.625 41.688 184.625 38.616V0.599976H191.473Z"
            fill="#1F1F1F"
          />
          <path
            d="M230.133 15L216.117 50.776C215.178 53.2506 214.154 55.2133 213.045 56.664C211.978 58.1146 210.741 59.16 209.333 59.8C207.925 60.44 206.282 60.76 204.405 60.76C202.869 60.76 201.44 60.5466 200.117 60.12C198.837 59.736 197.706 59.2026 196.725 58.52L198.389 53.208C199.2 53.8906 200.053 54.4026 200.949 54.744C201.888 55.0853 202.89 55.256 203.957 55.256C205.109 55.256 206.133 54.936 207.029 54.296C207.968 53.6986 208.8 52.4826 209.525 50.648L210.933 47.192L207.541 39.256L197.557 15H205.237L212.341 35.096L214.197 41.112L216.309 34.52L223.029 15H230.133Z"
            fill="#1F1F1F"
          />
          <path
            d="M251.847 47.64C249.969 47.64 248.241 47.2773 246.663 46.552C245.127 45.8266 243.825 44.824 242.759 43.544C241.692 42.2213 240.903 40.7493 240.391 39.128L241.223 38.04L240.711 47H234.695V0.599976H241.543V23.064L240.775 21.976C241.585 19.7573 242.972 17.944 244.935 16.536C246.897 15.0853 249.265 14.36 252.039 14.36C254.599 14.36 256.945 15.0213 259.079 16.344C261.255 17.6666 262.961 19.5653 264.199 22.04C265.436 24.5146 266.055 27.5226 266.055 31.064C266.055 34.52 265.415 37.4853 264.135 39.96C262.897 42.4346 261.191 44.3333 259.015 45.656C256.881 46.9786 254.492 47.64 251.847 47.64ZM250.375 42.136C253.148 42.136 255.303 41.1546 256.839 39.192C258.417 37.1866 259.207 34.456 259.207 31C259.207 27.544 258.439 24.8346 256.903 22.872C255.367 20.9093 253.212 19.928 250.439 19.928C248.647 19.928 247.089 20.3973 245.767 21.336C244.444 22.232 243.399 23.512 242.631 25.176C241.905 26.84 241.543 28.824 241.543 31.128C241.543 33.3893 241.905 35.352 242.631 37.016C243.356 38.6373 244.38 39.896 245.703 40.792C247.068 41.688 248.625 42.136 250.375 42.136Z"
            fill="#1F1F1F"
          />
          <path
            d="M287.428 14.36C290.542 14.36 293.294 15.0213 295.684 16.344C298.073 17.6666 299.929 19.5866 301.252 22.104C302.617 24.5786 303.3 27.544 303.3 31C303.3 34.456 302.617 37.4426 301.252 39.96C299.929 42.4346 298.073 44.3333 295.684 45.656C293.294 46.9786 290.542 47.64 287.428 47.64C284.313 47.64 281.561 46.9786 279.172 45.656C276.782 44.3333 274.905 42.4346 273.54 39.96C272.174 37.4426 271.492 34.456 271.492 31C271.492 27.544 272.174 24.5786 273.54 22.104C274.905 19.5866 276.782 17.6666 279.172 16.344C281.561 15.0213 284.313 14.36 287.428 14.36ZM287.428 19.736C285.508 19.736 283.865 20.184 282.5 21.08C281.177 21.9333 280.153 23.192 279.428 24.856C278.702 26.52 278.34 28.568 278.34 31C278.34 33.3893 278.702 35.4373 279.428 37.144C280.153 38.808 281.177 40.088 282.5 40.984C283.865 41.8373 285.508 42.264 287.428 42.264C289.348 42.264 290.969 41.8373 292.292 40.984C293.614 40.088 294.638 38.808 295.364 37.144C296.089 35.4373 296.452 33.3893 296.452 31C296.452 28.568 296.089 26.52 295.364 24.856C294.638 23.192 293.614 21.9333 292.292 21.08C290.969 20.184 289.348 19.736 287.428 19.736Z"
            fill="#1F1F1F"
          />
          <path
            d="M324.523 14.36C327.637 14.36 330.389 15.0213 332.779 16.344C335.168 17.6666 337.024 19.5866 338.347 22.104C339.712 24.5786 340.395 27.544 340.395 31C340.395 34.456 339.712 37.4426 338.347 39.96C337.024 42.4346 335.168 44.3333 332.779 45.656C330.389 46.9786 327.637 47.64 324.523 47.64C321.408 47.64 318.656 46.9786 316.267 45.656C313.877 44.3333 312 42.4346 310.635 39.96C309.269 37.4426 308.587 34.456 308.587 31C308.587 27.544 309.269 24.5786 310.635 22.104C312 19.5866 313.877 17.6666 316.267 16.344C318.656 15.0213 321.408 14.36 324.523 14.36ZM324.523 19.736C322.603 19.736 320.96 20.184 319.595 21.08C318.272 21.9333 317.248 23.192 316.523 24.856C315.797 26.52 315.435 28.568 315.435 31C315.435 33.3893 315.797 35.4373 316.523 37.144C317.248 38.808 318.272 40.088 319.595 40.984C320.96 41.8373 322.603 42.264 324.523 42.264C326.443 42.264 328.064 41.8373 329.387 40.984C330.709 40.088 331.733 38.808 332.459 37.144C333.184 35.4373 333.547 33.3893 333.547 31C333.547 28.568 333.184 26.52 332.459 24.856C331.733 23.192 330.709 21.9333 329.387 21.08C328.064 20.184 326.443 19.736 324.523 19.736Z"
            fill="#1F1F1F"
          />
          <path
            d="M377.938 15L363.666 29.592L362.194 30.616L352.146 41.048L352.082 33.24L369.81 15H377.938ZM354.578 0.599976V47H347.73V0.599976H354.578ZM364.498 25.752L378.706 47H370.77L359.378 29.656L364.498 25.752Z"
            fill="#1F1F1F"
          />
          <path
            d="M5.375 47.625H41.6562C41.8896 47.6251 42.119 47.5645 42.3218 47.4491C42.5246 47.3337 42.6939 47.1675 42.8129 46.9668C42.932 46.7661 42.9967 46.5379 43.0008 46.3046C43.0048 46.0713 42.9481 45.8409 42.8361 45.6362L35.1229 31.5L42.8361 17.3637C42.9481 17.159 43.0048 16.9287 43.0008 16.6954C42.9967 16.462 42.932 16.2338 42.8129 16.0331C42.6939 15.8324 42.5246 15.6662 42.3218 15.5508C42.119 15.4354 41.8896 15.3748 41.6562 15.375L5.375 15.375C3.94946 15.375 2.58231 15.9413 1.5743 16.9493C0.566293 17.9573 -6.23123e-08 19.3244 0 20.75L9.39795e-07 42.25C1.00211e-06 43.6755 0.566294 45.0427 1.5743 46.0507C2.58231 47.0587 3.94946 47.625 5.375 47.625Z"
            fill="#1F1F1F"
          />
        </svg>
      </div>
    </a>
  );
}

function HeaderButton({ useCurrentStep, index, children }) {
  const [currentStepIndex, setCurrentStepIndex] = useCurrentStep();
  return (
    <button
      data-is-active={currentStepIndex >= index}
      onClick={() =>
        currentStepIndex > index ? setCurrentStepIndex(index) : null
      }
    >
      {children}
    </button>
  );
}
